"use strict";module.exports=Function.prototype.apply;